import { render, staticRenderFns } from "./TableAndRing.vue?vue&type=template&id=0edc76b1"
import script from "./TableAndRing.vue?vue&type=script&lang=js"
export * from "./TableAndRing.vue?vue&type=script&lang=js"
import style0 from "./TableAndRing.vue?vue&type=style&index=0&id=0edc76b1&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports